import { AdProducts } from "modules/whatsappAdProducts";

const WhatsAppAdProductsPage = () => {
  return <AdProducts />;
};

export default WhatsAppAdProductsPage;
